module.exports = __webpack_public_path__ + "static/img/ATEE.9d2715a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ATEE.png
// module id = X0qy
// module chunks = 0